import React, { FC, ReactNode } from 'react';

import { Layout, Secure } from '@/components';
import { FeaturesProvider, ThemeProvider, ViewerProvider } from '@/contexts';
import './layout.css';

export const BaseWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Secure>
      <ViewerProvider>
        <ThemeProvider>
          <FeaturesProvider>
            <Layout>{children}</Layout>
          </FeaturesProvider>
        </ThemeProvider>
      </ViewerProvider>
    </Secure>
  );
};
